// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-no-translate]{translate:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.FR9jJ{padding:10px 0}@media only screen and (max-width: 767px){.FR9jJ .TCTjP{padding-bottom:0;padding-top:0}}.KO7eH{margin-left:15px}@media only screen and (max-width: 767px){.KO7eH{padding:4px 0}}.H1vku{float:left;min-width:300px;width:auto}.a8nm6{width:100%}.j0ASs{display:none}.KO7eH label>span:nth-last-child(1){font-size:15px}@media(max-width: 991px){.KO7eH label>span:nth-last-child(1){line-height:17px}}.BUCud{width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"answersContainer": "FR9jJ",
	"noneVerticalPadding": "TCTjP",
	"marginLeft": "KO7eH",
	"smallField": "H1vku",
	"fullWidth": "a8nm6",
	"hide": "j0ASs",
	"trueOrFalseField": "BUCud"
};
module.exports = ___CSS_LOADER_EXPORT___;
